define("settings/components/cancel-plan/slide/knowledge-base-content", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tCA--title">{{@kbContent.title}}</p>
  <p class="u--m__b__lg">
    {{@kbContent.subCopy}}
  
    <Shared::Link @href={{@kbContent.kb.link}} @text={{@kbContent.kb.text}} class="u--inline" />
  </p>
  */
  {
    "id": "/lfVKoMY",
    "block": "[[[10,2],[14,0,\"tCA--title\"],[12],[1,[30,1,[\"title\"]]],[13],[1,\"\\n\"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n  \"],[1,[30,1,[\"subCopy\"]]],[1,\"\\n\\n  \"],[8,[39,0],[[24,0,\"u--inline\"]],[[\"@href\",\"@text\"],[[30,1,[\"kb\",\"link\"]],[30,1,[\"kb\",\"text\"]]]],null],[1,\"\\n\"],[13]],[\"@kbContent\"],false,[\"shared/link\"]]",
    "moduleName": "settings/components/cancel-plan/slide/knowledge-base-content.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});